import * as Dashboard from './Dashboard';
import * as Gerenciamento from './Gerenciamento';
import * as Relatorio from './Relatorio';

export default {
  Dashboard,
  Gerenciamento,
  Relatorio,
};
